export const COMMENTS = {
  TITLE: 'Comments',
  DESCRIPTION: 'Please provide:',
  DESCRIPTION_LIST: [
    'Any additional information to assist the REACH BC Office with approving your study.',
    'If you are editing the study posting and have made changes, list them here.',
  ],
  DESCRIPTION_TWO: 'E.g. “Post - Amendment Approval certificate has been added and study contact information has been updated”.',
};
